import Error from "components/form/Error";
import DrawerButton from "components/form/Franchise-vendor-vehicleallot-drawerbtn";
import DrawerPreviousNext from "components/form/DrawerPreviousNext";
import DrawerCancelNext from "components/form/DrawerCancelNext";
import React, { useState, useEffect } from "react";
import InputArea from "components/form/InputArea";
import LabelArea from "components/form/LabelArea";
import Title from "components/form/Title";
import InputAreaDate from "components/form/InputAreaDate";
import useVendorAlotSubmit from "hooks/useVendorAlotSubmit";
import VendorServices from "services/VendorAlotServices";
import Scrollbars from "react-custom-scrollbars-2";
import ActiveButton from "components/form/ActiveButton";
import SelectVendor from "components/form/SelectVendor";

const VendorAlotDrawer = ({
  id,
  start_date,
  end_date,
  vendor_id,
  vendor_name,
  type,
  modalData,
  tab,
  days,
  package_type,
  latest_va_id,
  is_vehicle_alloted,
  vendorAction,
  vendorAllotAction,
  clientArrived,
  tripWentOrNot,
}) => {
  const [isResponseEmpty, setIsResponseEmpty] = useState(true);
  //console.log(package_type)
  useEffect(() => {
    const fetchVendorData = async () => {
      try {
        const response = await VendorServices.getVendorbyClientid(id, {
          service_type: package_type,
        });

        if (response?.data && response.data.length > 0) {
          setIsResponseEmpty(false); // Response is not empty
        } else {
          setIsResponseEmpty(true); // Response is empty
        }
      } catch (error) {
        // console.error("Error fetching vendor data:", error);
        setIsResponseEmpty(true);
      }
    };

    if (id) fetchVendorData();
  }, [id]);

  const {
    register,
    handleNextStep,
    handlePreviousStep,
    handleSubmit,
    onSubmit,
    tripwent,
    setTrip,
    trigger,
    setChangeReason,
    setEndDate,
    setStartDate,
    errors,
    goToStep,
    step,
    selectedReferenceNo,
    handleReferenceChange,
    startDate,
    endDate,
    loading,
  } = useVendorAlotSubmit(
    id,
    tab,
    start_date,
    end_date,
    vendor_id,
    package_type,
    latest_va_id,
    vendorAction,
    vendorAllotAction,
  );

  const parseDate = (dateStr) => {
    if (!dateStr) {
      //console.error("Invalid date string:", dateStr);
      return null; // Return null or a default value for invalid input
    }
    const [day, month, year] = dateStr.split("-");
    return new Date(`${year}-${month}-${day}`);
  };
  const [tripWentContent, setTripWentContent] = useState("");
  const client_end_date = end_date ? parseDate(end_date) : null;
  const bookingStartDate = parseDate(start_date);
  const bookingEndDate = parseDate(end_date);

  useEffect(() => {
    // Trip Went is not applicable for these package types
    if (
      ["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type)
    ) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // Outstation, Oneway & Holiday Package:
    // Trip Went is applicable only when days > 1
    if (
      ["Outstation", "Oneway", "Holiday Package"].includes(package_type) &&
      Number(days) <= 1
    ) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // Trip was already completed earlier
    if (tripWentOrNot === "1") {
      setTrip(true);
      return;
    }

    // Vehicle is not allotted OR client has not arrived
    if (!is_vehicle_alloted || !clientArrived) {
      setTrip(false);
      setStartDate(parseDate(start_date));
      return;
    }

    // Vehicle allotted AND client arrived
    setTrip(true);
  }, [
    tripWentOrNot,
    is_vehicle_alloted,
    clientArrived,
    start_date,
    package_type,
    days,
  ]);

  // const showTripWent =
  //   vendorAction === "modify" &&
  //   !["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type) &&
  //   (package_type !== "Outstation" || Number(days) > 1);

  const showTripWent =
    vendorAction === "modify" &&
    !["Airport Pickup", "Airport Drop", "Hour Rental"].includes(package_type) &&
    ((package_type !== "Outstation" &&
      package_type !== "Holiday Package" &&
      package_type !== "Oneway") ||
      Number(days) > 1);
  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {vendor_name ? (
          <Title title={"Modify Vendor"} />
        ) : (
          <Title title={"Allot Vendor"} />
        )}
      </div>
      <div className="text-sm font-medium text-center text-gray-500 border-b border-gray-200  dark:border-gray-600 dark:bg-gray-700 dark:text-gray-400">
        <ul className="flex flex-wrap -mb-px">
          {[
            ...(vendorAction !== "modify"
              ? [{ tabValue: 1, labelName: "Allot" }]
              : [
                  { tabValue: 1, labelName: "Modify" },
                  { tabValue: 2, labelName: "New Vendor" },
                ]),
          ].map(({ tabValue, labelName }) => (
            <li className="mr-2" key={tabValue}>
              <ActiveButton
                tabValue={tabValue}
                labelName={labelName}
                goToStep={goToStep}
                step={step}
              />
            </li>
          ))}
        </ul>
      </div>
      {/* {console.log(package_type)} */}
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="px-6 pt-8 scrollbar-hide flex-grow w-full h-full max-h-full pb-40 md:pb-32 lg:pb-32 xl:pb-32">
            {step === 1 && (
              <>
                {vendorAction !== "modify" ? (
                  <>
                    <div className="col-span-8 sm:col-span-4">
                      <SelectVendor
                        register={register}
                        label="Vendor Reference No"
                        name="vendor_id"
                        id={id}
                        vendor_name={vendor_name}
                        vendor_id={vendor_id}
                        package_type={package_type}
                        selectedReferenceNoId={selectedReferenceNo}
                        handleReferenceNoChange={handleReferenceChange}
                      />
                      <Error errorName={errors.vendor_id} />
                    </div>
                    <DrawerButton
                      isSubmitting={loading}
                      id={id}
                      title="Assign"
                      Action={vendorAction}
                      allotname={"vendor"}
                    />
                  </>
                ) : null}

                {/* {vendorAction === "modify" && days > 1 ? ( */}
                {vendorAction === "modify" ? (
                  <>
                    <div className="grid grid-cols-6 gap-5 mb-3">
                      {/* {showTripWent && (
                        <div className="col-span-6 sm:col-span-6">
                          {tripWentOrNot === "1" ? (
                            <p className="text-sm text-red-600 mb-2">
                              This trip was previously completed. “No” cannot be
                              selected.
                            </p>
                          ) : !is_vehicle_alloted ? (
                            <p className="text-sm text-red-600 mb-2">
                              Vehicle has not been allotted yet. Trip Went
                              option will be available once the vehicle is
                              allotted.
                            </p>
                          ) : !clientArrived ? (
                            <p className="text-sm text-red-600 mb-2">
                              Client has not arrived yet. Trip Went option will
                              be available once the client arrives.
                            </p>
                          ) : null}

                          <LabelArea label={"Trip Went:"} />

                          <div className="flex items-center space-x-4">
               
                            <label
                              className={`flex items-center ${
                                tripWentOrNot === "1" ||
                                !is_vehicle_alloted ||
                                !clientArrived
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                            >
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === false}
                                disabled={
                                  tripWentOrNot === "1" ||
                                  !is_vehicle_alloted ||
                                  !clientArrived
                                }
                                className="mr-2"
                                onChange={() => {
                                  setTrip(false);
                                  setStartDate(parseDate(start_date));
                                }}
                              />
                              No
                            </label>

             
                            <label
                              className={`flex items-center ${
                                !is_vehicle_alloted || !clientArrived
                                  ? "opacity-50 cursor-not-allowed"
                                  : ""
                              }`}
                            >
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === true}
                                disabled={!is_vehicle_alloted || !clientArrived}
                                className="mr-2"
                                onChange={() => setTrip(true)}
                              />
                              Yes
                            </label>
                          </div>

                          <Error errorName={errors.tripwent} />
                        </div>
                      )} */}

                      {showTripWent && (
                        <div className="col-span-6 sm:col-span-6">
                          {tripWentOrNot === "1" ? (
                            <p className="text-sm text-red-600 mb-2">
                              This trip was previously completed. “No” cannot be
                              selected.
                            </p>
                          ) : !is_vehicle_alloted ? (
                            <p className="text-sm text-red-600 mb-2">
                              Vehicle has not been allotted yet. Trip Went
                              option will be available once the vehicle is
                              allotted.
                            </p>
                          ) : !clientArrived ? (
                            <p className="text-sm text-red-600 mb-2">
                              Client has not arrived yet. Trip Went option will
                              be available once the client arrives.
                            </p>
                          ) : null}

                          <LabelArea label={"Trip Went:"} />

                          <div className="flex items-center space-x-4">
                            {/* NO */}
                            <label
                              className={`flex items-center ${
                                tripWentOrNot === "1" ||
                                !is_vehicle_alloted ||
                                !clientArrived
                                  ? "opacity-100"
                                  : "cursor-pointer"
                              }`}
                            >
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === false}
                                className="mr-2"
                                onChange={() => {
                                  if (
                                    tripWentOrNot === "1" ||
                                    !is_vehicle_alloted ||
                                    !clientArrived
                                  ) {
                                    return;
                                  }

                                  setTrip(false);
                                  setStartDate(parseDate(start_date));
                                }}
                              />
                              No
                            </label>

                            {/* YES */}
                            <label
                              className={`flex items-center ${
                                !is_vehicle_alloted || !clientArrived
                                  ? "opacity-100"
                                  : "cursor-pointer"
                              }`}
                            >
                              <input
                                type="radio"
                                name="tripwent"
                                checked={tripwent === true}
                                className="mr-2"
                                onChange={() => {
                                  if (!is_vehicle_alloted || !clientArrived) {
                                    return;
                                  }

                                  setTrip(true);
                                }}
                              />
                              Yes
                            </label>
                          </div>

                          <Error errorName={errors.tripwent} />
                        </div>
                      )}

                      <div className="col-span-8 sm:col-span-6">
                        <LabelArea label={"Reason"} />
                        <InputArea
                          register={register}
                          label="Reason"
                          name="reason"
                          type="text"
                          onChange={(e) => setChangeReason(e.target.value)}
                          placeholder={"Enter Reason"}
                        />
                        {/* <Error errorName={errors.reason} /> */}
                        {tripwent && (
                          <p className="mt-4 mb-0 text-sm">
                            New vendor start date
                          </p>
                        )}
                      </div>
                      {tripwent && (
                        <>
                          <div className="col-span-3">
                            <LabelArea label="Start Date" />
                            {/* <InputAreaDate
                              trigger={trigger}
                              register={register}
                              label="Start Date"
                              name="client_start_date"
                              type="date"
                              value={new Date(startDate)}
                              onChange={(e) => {
                                setStartDate(e.target.value);
                              }}
                              min={new Date(startDate)}
                              max={new Date(endDate)}
                              // readOnly={true} // Set to true to disable the input
                            /> */}

                            <InputAreaDate
                              trigger={trigger}
                              register={register}
                              label="Start Date"
                              name="client_start_date"
                              type="date"
                              // value={startDate}
                              value={startDate}
                              min={bookingStartDate || new Date(startDate)}
                              max={bookingEndDate}
                              // onChange={(date) => setStartDate(date)}
                              onChange={(date) => {
                                setStartDate(date);
                              }}
                            />

                            <Error errorName={errors.start_date} />
                          </div>

                          <div className="col-span-3">
                            <LabelArea label="End Date" />
                            <InputAreaDate
                              trigger={trigger}
                              register={register}
                              label="End Date"
                              name="client_end_date"
                              type="date"
                              placeholder="dd/mm/yyyy"
                              value={new Date(endDate).setDate(
                                // new Date(endDate).getDate() - 1
                                new Date(endDate).getDate(),
                              )}
                              onChange={(event) => {
                                const selectedDate = new Date(event);
                                setEndDate(
                                  new Date(
                                    selectedDate.setDate(
                                      selectedDate.getDate(),
                                    ),
                                  ),
                                ); // Adjust state to account for the offset
                              }}
                              min={new Date(startDate)}
                              max={
                                new Date(
                                  new Date(client_end_date).setDate(
                                    // new Date(client_end_date).getDate() - 1
                                    new Date(client_end_date).getDate(),
                                  ),
                                )
                              }
                              readOnly={true} // Set to true to disable the input
                            />
                            <Error errorName={errors.end_date} />
                          </div>
                        </>
                      )}
                      <DrawerCancelNext handleNextStep={handleNextStep} />
                    </div>
                  </>
                ) : (
                  <>
                    {vendorAction === "modify" && (
                      <div className="grid grid-cols-6 gap-5 mb-3">
                        <div className="col-span-6">
                          <LabelArea label={"Reason"} />
                          <InputArea
                            register={register}
                            label="Reason"
                            name="reason"
                            type="text"
                            onChange={(e) => setChangeReason(e.target.value)}
                            placeholder={"Enter Reason"}
                          />
                          <Error errorName={errors.reason} />
                        </div>

                        <DrawerCancelNext handleNextStep={handleNextStep} />
                      </div>
                    )}
                  </>
                )}
              </>
            )}

            {step === 2 && vendorAction === "modify" && (
              <>
                <div className="grid grid-cols-6 gap-3 mb-6">
                  <div className="col-span-6">
                    <LabelArea label={"Vendor Name"} />
                    <SelectVendor
                      register={register}
                      label="Vendor"
                      name="vendor_id"
                      id={id}
                      vendor_name={vendor_name}
                      vendor_id={vendor_id}
                      selectedReferenceNoId={selectedReferenceNo}
                      package_type={package_type}
                      handleReferenceNoChange={handleReferenceChange}
                    />
                    <Error errorName={errors.vendor_id} />
                  </div>

                  {/* <div className="col-span-3">
                    <LabelArea label="Start Date" />
                    <InputAreaDate
                      trigger={trigger}
                      register={register}
                      label="Start Date"
                      name="start_date"
                      type="date"
                      value={tripwent ? new Date(endDate) : new Date(startDate)}
                       onChange={(e)=>{setStartDate(e.target.value)
               
                      }}
                      min={new Date(startDate)}
                      max={new Date(endDate)}
                      readOnly={true}
                    />
                    <Error errorName={errors.start_date} />
                 
                  </div> */}

                  {/* <div className="col-span-3">
                    <LabelArea label="End Date" />
                    <InputAreaDate
                      trigger={trigger}
                      register={register}
                      label="End Date"
                      name="end_date"
                      type="date"
                      placeholder="dd/mm/yyyy"
                      value={new Date(client_end_date)}
                      min={new Date(startDate)}
                      max={new Date(endDate)}
                      readOnly={true} // Set to true to disable the input
                    />
                    <Error errorName={errors.end_date} />
                  </div> */}
                  {/* {console.log(endDate)} */}
                </div>

                <DrawerPreviousNext
                  isSubmitting={loading}
                  handleNextStep={handleNextStep}
                  handlePreviousStep={handlePreviousStep}
                />
                <DrawerButton
                  id={id}
                  isSubmitting={loading}
                  title={vendorAction === "modify" ? "Update" : "Assign"}
                  Action={vendorAction}
                  allotname={"Vendor"}
                />
              </>
            )}
          </div>
        </form>
      </Scrollbars>
    </>
  );
};

export default VendorAlotDrawer;
